<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5 11L23.5 11" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.5 21H23.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 14C12.6716 14 12 14.6716 12 15.5V16.5C12 17.3284 12.6716 18 13.5 18H18.5C19.3284 18 20 17.3284 20 16.5V15.5C20 14.6716 19.3284 14 18.5 14H13.5Z" fill="currentColor"/>
</svg>
